import { useEffect, useState } from "react";
import AdminHeader from "../../components/layout/AdminHeader";
import { api } from "../../lib/api";
import { toast } from "sonner";

const statuses = ["requested", "pending", "scheduled", "completed", "rescheduled", "cancelled", "no_show"];
const statusLabel = { requested: "Requested", pending: "Pending", scheduled: "Scheduled", completed: "Completed", rescheduled: "Rescheduled", cancelled: "Cancelled", no_show: "No show" };

export default function AdminConsultations() {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/consultations").then((r) => setList(r.data)); }, []);

  const update = async (id, patch) => {
    try { await api.patch(`/consultations/${id}`, patch);
      const { data } = await api.get("/consultations"); setList(data);
      toast.success("Updated");
    } catch { toast.error("Failed"); }
  };

  return (
    <div data-testid="page-admin-consultations">
      <AdminHeader breadcrumb="Investor Relations" title="Consultations" subtitle="Consultation requests, scheduled calls, and follow-ups." />
      <div className="p-8">
        <div className="admin-card">
          <table className="w-full text-sm">
            <thead className="text-[11px] uppercase tracking-[0.15em] text-altura-charcoal/50">
              <tr className="border-b border-altura-espresso/10">
                <th className="text-left py-3 px-2">Investor</th><th className="text-left py-3 px-2">Email</th>
                <th className="text-left py-3 px-2">Market</th><th className="text-left py-3 px-2">Type</th>
                <th className="text-left py-3 px-2">Status</th><th className="text-left py-3 px-2">Requested</th>
              </tr>
            </thead>
            <tbody>
              {list.map((c) => (
                <tr key={c.id} className="border-b border-altura-espresso/5" data-testid={`consultation-row-${c.id}`}>
                  <td className="py-3 px-2 font-medium text-altura-espresso">{c.lead_name || "—"}</td>
                  <td className="py-3 px-2 text-altura-charcoal/75">{c.lead_email}</td>
                  <td className="py-3 px-2">{c.market || "—"}</td>
                  <td className="py-3 px-2 capitalize">{c.type}</td>
                  <td className="py-3 px-2">
                    <select value={c.status} onChange={(e) => update(c.id, { status: e.target.value })} className="admin-select w-40 text-xs" data-testid={`consultation-status-${c.id}`}>
                      {statuses.map((s) => <option key={s} value={s}>{statusLabel[s]}</option>)}
                    </select>
                  </td>
                  <td className="py-3 px-2 font-mono text-[11px] text-altura-charcoal/50">{new Date(c.requested_at).toLocaleString()}</td>
                </tr>
              ))}
              {list.length === 0 && <tr><td colSpan="6" className="text-center py-10 text-altura-charcoal/50">No consultation requests yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
